// extracted by mini-css-extract-plugin
export default {"schoolName":"ADSbZVD4Tr0Py46Hc38R"};